import { render, staticRenderFns } from "./Management-payment.vue?vue&type=template&id=543bbb4d&scoped=true&"
import script from "./Management-payment.vue?vue&type=script&lang=js&"
export * from "./Management-payment.vue?vue&type=script&lang=js&"
import style0 from "./Management-payment.vue?vue&type=style&index=0&id=543bbb4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543bbb4d",
  null
  
)

export default component.exports